$(function() {
	window.addEventListener('scroll', function () {
		let header = document.querySelector('.js-header');
		header.classList.toggle('header_scroll', window.scrollY > 0);
	});

	$('.js-burger').click(function () {
		$(this).toggleClass('burger_active');
		$('.header').toggleClass('header_active');
		$('.header__nav').toggleClass('header__nav_active');
		$('body').toggleClass('o-hidden');
	});
})